__turbopack_context__.v({
  "header": "F5xR6a_header",
  "message": "F5xR6a_message",
  "shimmer": "F5xR6a_shimmer",
  "subtitle": "F5xR6a_subtitle",
  "text-bar-sweep": "F5xR6a_text-bar-sweep",
  "title": "F5xR6a_title",
});
